import { render, staticRenderFns } from "./DividingHeader.vue?vue&type=template&id=6e377ca6"
import script from "./DividingHeader.vue?vue&type=script&lang=js"
export * from "./DividingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports